<!-- src/app/lang-change/lang-change.component.html -->
<div id='lang' class="homemenu" style="float: right;margin:10px 15px 0 0;" appDynamicDirection>
    <a href="/en{{url}}" class="eng-click" [class.lang_active]="currentLang === 'en'">ENGLISH</a>
    <span> | </span>
    <a href="/fr{{url}}" class="fr-click" [class.lang_active]="currentLang === 'fr'">FRANÇAIS</a>
    <span> | </span>
    <a href="/es{{url}}" class="es-click" [class.lang_active]="currentLang === 'es'">ESPAÑOL</a>
    <span> | </span>
    <a href="/pt{{url}}" class="pt-click" [class.lang_active]="currentLang === 'pt'">PORTUGUÊS</a>
    <span> | </span>
    <a href="/ko{{url}}" class="ko-click" [class.lang_active]="currentLang === 'ko'">한국어</a>
    <span> | </span>
    <a href="/ar{{url}}" class="ar-click" [class.lang_active]="currentLang === 'ar'">العربية</a>
</div>


// WEBPACK FOOTER //
// ./src/app/lang-change/lang-change.component.html